import cabinetStyle from "./MentorCabinet.module.css";
import PageTips from "../PageTips";
import React, {useEffect, useState} from "react";
import * as UserService from "../../api/UserService"
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";


export default function MentorCabinetGameSettings(props) {
    const [on6selectedMove, setOn6selectedMove] = useState(true)
    const [on66XselectedMoveWithSnakesAndArrows, setOn66XselectedMoveWithSnakesAndArrows] = useState(false)
    const [on6666XselectedMoveWithSnakesAndArrows, setOn6666XselectedMoveWithSnakesAndArrows] = useState(false)
    const [highlightSteps, setHighlightSteps] = useState(true)
    const [allowAllFieldsView, setAllowAllFieldsView] = useState(false)
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false)
    const [justSaved, setJustSaved] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'mentorCabinetGameSettings' });

    function saveUserSettings() {
        if (saveButtonDisabled) {
            return
        }
        setSaveButtonDisabled(true)
        UserService.saveUserSettings(
            on6selectedMove,
            on66XselectedMoveWithSnakesAndArrows,
            on6666XselectedMoveWithSnakesAndArrows,
            highlightSteps,
            allowAllFieldsView,
            () => {
                setSaveButtonDisabled(false)
                setJustSaved(true)
                trySetTimeout(()=> {setJustSaved(false)}, 3000)
                getUserSettings()

            },
            () => {window.alert(t('couldNotSaveError'))}
            )
    }

    function getUserSettings() {
        UserService.getUserSettings(
            (res) => {
                setOn6selectedMove(res.game_behaviour_at_6 === "move")
                setOn66XselectedMoveWithSnakesAndArrows(res.game_behaviour_at_6x_or_66x === "move_with_snakes_and_arrows")
                setOn6666XselectedMoveWithSnakesAndArrows(res.game_behaviour_at_6666x_or_more === "move_with_snakes_and_arrows")
                setHighlightSteps(res.game_view_highlight_steps === true)
                setAllowAllFieldsView(res.game_view_enable_view_all_cells === true)
            },
            () => window.alert(t('couldNotGetSettingsError'))
        )
    }

    useEffect(() => {
        getUserSettings()
    }, [])


    return <div className={cabinetStyle.mainPageContainer}>
        <PageTips headerText={t('header')}>
            <div>{t('headerText')}</div>
        </PageTips>
        <div className={`${cabinetStyle.settingsContainer}`}>
            <div className={cabinetStyle.settingSection}>
                <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                    <input type="checkbox" name="highlightStepsSetting" checked={highlightSteps}
                           onClick={() => setHighlightSteps(!highlightSteps)}/>
                    <span>{t('highlightPlayerStepsOnFieldSetting')}</span>
                </div>
            </div>
            <br/>
            <div className={cabinetStyle.settingSection}>
                <span>{t('allowAllFieldsViewSetting')}</span>
                <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                    <input type="radio" name="allowAllFieldsView" checked={allowAllFieldsView}
                           onClick={() => setAllowAllFieldsView(true)}/>
                    <span>{t('allowAllFieldsViewSettingTrue')}</span>
                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                    <input type="radio" name="allowAllFieldsView" checked={!allowAllFieldsView}
                           onClick={() => setAllowAllFieldsView(false)}/>
                    <span>{t('allowAllFieldsViewSettingFalse')}</span>
                </div>
            </div>
            <br/>
            <div className={cabinetStyle.settingSection}>
                <span>{t('sixOnDice')}</span>
                <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                    <input type="radio" name="on6" checked={on6selectedMove} onClick={() => setOn6selectedMove(true)}/>
                    <span>{t('moveNow')}</span>
                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                    <input type="radio" name="on6" checked={!on6selectedMove}
                           onClick={() => setOn6selectedMove(false)}/>
                    <span>{t('rememberAndWait')}</span>
                </div>

            </div>
            <br/>
            {!on6selectedMove && <div>
                <div className={cabinetStyle.settingSection}>
                    <span>{t('comboOnDice')} <b>6-Х</b> {t('or')} <b>6-6-Х</b> ({t('where')} Х <i>{t('not')} 6</i>):</span>
                    <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                        <input type="radio" name="on66x" checked={on66XselectedMoveWithSnakesAndArrows}
                               onClick={() => setOn66XselectedMoveWithSnakesAndArrows(true)}/>
                        <span>{t('moveOnEachStepInclSnakesAndArrows')}</span>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                        <input type="radio" name="on66x" checked={!on66XselectedMoveWithSnakesAndArrows}
                               onClick={() => setOn66XselectedMoveWithSnakesAndArrows(false)}/>
                        <span>{t('moveOnTotalSum')}</span>
                    </div>
                </div>
                <br/>
                <div className={cabinetStyle.settingSection}>
                    <span>{t('onFour6OrMore')}<i>{t('not6')}</i></span>
                    <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                        <input type="radio" name="on6666x" checked={on6666XselectedMoveWithSnakesAndArrows}
                               onClick={() => setOn6666XselectedMoveWithSnakesAndArrows(true)}/>
                        <span>{t('moveOnEachStepInclSnakesAndArrows')}</span>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                        <input type="radio" name="on6666x" checked={!on6666XselectedMoveWithSnakesAndArrows}
                               onClick={() => setOn6666XselectedMoveWithSnakesAndArrows(false)}/>
                        <span>{t('moveOnTotalSum')}</span>
                    </div>
                </div>
                <br/>
            </div>}
            <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                <div
                    className={saveButtonDisabled ? cabinetStyle.saveSettingsButtonDisabled : cabinetStyle.saveSettingsButton}
                    style={justSaved ? {backgroundColor: "green"}: {}}
                    onClick={saveUserSettings}>{justSaved ? "✅ " + t('saved') : t('save')}
                </div>
            </div>

        </div>
    </div>
}